import { SHOW_QUICK_DONATE_POP, HIDE_QUICK_DONATE_POP } from "redux/types";

const initialState = {
  quickDonateStatus: false,
};

export const setQuickDonatePopStateReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SHOW_QUICK_DONATE_POP:
      return { ...state, quickDonateStatus: action.payload };
    case HIDE_QUICK_DONATE_POP:
      return { ...state, quickDonateStatus: action.payload };
    default:
      return state;
  }
};
